import Vuex from 'vuex';
import Vue from 'vue';
import defaultTemplate from './modules/default';
import ziraatTemplate from './modules/ziraat';
import yapikrediTemplate from './modules/yapikredi';

const state = {
  setLoading: false,
  alert: {
    show: false,
    message: '',
    type: ''
  },
  token: '',
  symbols: [],
  cdnPath: process.env.VUE_APP_CDN_URL,
  showDeniedMessage: false,
  //parentDomains: ['http://localhost:3000'],
  parentDomains: ['https://temelanaliz-test.matriksdata.com', 'https://temelanaliz.matriksdata.com', 'https://matriks-test.matrikswebtrader.com', 'https://matriks-dev.matrikswebtrader.com', 'https://app.matrikswebtrader.com', 'https://matriks-pilot.matrikswebtrader.com', 'https://www.matriksdata.com', 'https://web.matriksdata.com'],
  hideLogo: false,
  lang: 'tr',
  exceptionalPeriods: {
    period: 202312,
    paintPeriods: ['2022/12', '2023/12']
  },
  theme: 'dark-theme',
  alternative_title_symbols: ['ALBRK'],
  CHECK_ZERO_BARCHART_PERIOD: 202406,
  ZERO_BARCHART_PERIOD: 202309,
  issuerTemplates: {
    ZRTYAT: 'ziraat',
    ZRTYATDLYD: 'ziraat',
    YKYATIRIM: 'yapikredi',
    YKYGECIKMELI: 'yapikredi'
  },
  template: 'default',
  exportKey: '2545a39b-5ed7-448b-a7f8-2ebe71381952'
};

const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  }
}

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: debug,
  state: state,
  mutations: mutations,
  modules: {
    default: defaultTemplate,
    ziraat: ziraatTemplate,
    yapikredi: yapikrediTemplate
  }
});
